import { useCallback, useEffect, useState } from 'react'
import { listGuides, deleteGuide } from '../services/guides'

// Loads the current user's guides. `params` ({ q, topics, items }) re-fetches when
// it changes (used by the Guides tab); pickers can call it with no params.
export function useGuides(params = {}) {
  const [guides, setGuides] = useState([])
  const [status, setStatus] = useState('loading') // loading|ready|error
  const { q, topics, items } = params
  const topicsKey = (topics || []).join(',')
  const itemsKey = (items || []).join(',')

  const load = useCallback(() => {
    let alive = true
    setStatus('loading')
    listGuides({ q, topics, items })
      .then((list) => {
        if (!alive) return
        setGuides(list)
        setStatus('ready')
      })
      .catch(() => alive && setStatus('error'))
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, topicsKey, itemsKey])

  useEffect(() => load(), [load])

  const removeGuide = useCallback(async (id) => {
    await deleteGuide(id)
    setGuides((prev) => prev.filter((g) => g._id !== id))
  }, [])

  // Insert or replace a guide locally (after create/edit) without a refetch.
  const upsertGuide = useCallback((guide) => {
    if (!guide?._id) return
    setGuides((prev) => {
      const exists = prev.some((g) => g._id === guide._id)
      return exists ? prev.map((g) => (g._id === guide._id ? guide : g)) : [guide, ...prev]
    })
  }, [])

  return { guides, status, reload: load, removeGuide, upsertGuide }
}
